// controllerHandler.js
var ControllerHandler = pc.createScript('controllerHandler');

ControllerHandler.attributes.add('anim1', {type:'asset', title: 'anim1'});
ControllerHandler.attributes.add('anim2', {type:'asset', title: 'anim2'});
ControllerHandler.attributes.add('modules', {type:'entity', title: 'modules'});
ControllerHandler.attributes.add('sceneIndex', {type: 'string', title: 'scenes', array: true});
ControllerHandler.attributes.add('sounds', {type:'asset', title: 'sounds: ', array:true});

// initialize code called once per entity
ControllerHandler.prototype.initialize = function() {
    this.app.on('controller:register', this.onControllerRegister, this); // if a controller is registered
    this.app.on('controller:button', this.onButton, this); // if any controller button is pushed
    this.app.on('controller:axisY', this.onControllerAxisY, this); // if controller axis
    this.app.on('controller:axisX', this.onControllerAxisX, this); // if controller axis
    this.app.on('controller:loadScene', this.loadScene, this); // if trigger button when menu
    this.app.on('controller:stick', this.move, this); // let thumbstick rotate to input
    this.app.on('controller:stickRotate', this.rotate, this); // let thumbstick rotate to input
    animL = null; // animation component of left controller
    animR = null;// animation component of right controller
    lTrigOnce = true;   rTrigOnce = true;   lGripOnce = true;   rGripOnce = true; // onetime bools for buttons 
    oneTimeAxL = true; oneTimeAxR = true; // once for Yaxis for cycling through modules
    cntrlLeft = null; // left controller
    cntrlRight = null; // right controller
    configEnt = null; // entity holding submenu (module) configuration
    tConfig = null; // array with submenu entities (modules) representig configuration for controlles in scene
    moduleCounterL = 0; // for cycling through modules
    moduleCounterR = 0; // for cycling through modules
    entLeft = new Array([0]);
    entRight = new Array([0]);
    mcL = null;
    mcR = null;
    this.onSceneInit(); // init controller scene config (for modules)
    this.sceneCounter = 1;
    this.tMenu = false;
    this.soundHolderL = null;
    this.soundHolderR = null;
    this.pSystemFloatL = null;
    this.pSystemFloatR = null;
    this.stickLeft = null;
    this.stickRight = null;
    this.stickRotLeft = null;
    this.stickRotRight = null;
    this.teleCubeL = null;
    this.teleCubeR = null;
    this.moveSndLoopL = true;
    this.moveSndLoopR = true;
    this.app.xr.on('end', this.endXR, this);

};

ControllerHandler.prototype.endXR = function(){
    this.app.root.findByName('burger').enabled = true;
   location.reload();
};

ControllerHandler.prototype.onSceneInit = function() {
    configEnt = this.app.root.findByName('menuConfig');
    tConfig = configEnt.script.menuConfigContainer.menuConf; // gets array with module config per scene from menuconfig entity in root
};

ControllerHandler.prototype.onControllerRegister = function(ent, hnd) {
    if(hnd == 'left'){
        cntrlLeft = ent; // know the name of the controller entity!
        animL = ent.children[2].animation; // and it's 3dmodel's animation
        mcL = cntrlLeft.children[3].findByName(tConfig[0].name); // finding the coressponding module for the hand
        this.soundHolderL = cntrlLeft.children[4];
        this.pSystemFloatL = cntrlLeft.children[5];
        this.stickLeft = cntrlLeft.children[3].findByName('move').children[3];
        this.stickRotLeft = cntrlLeft.children[3].findByName('rotate').children[3];
        this.teleCubeL = cntrlLeft.children[1].children[2];
    } else if (hnd == 'right'){
        cntrlRight = ent;
        animR = ent.children[2].animation;
        mcR = cntrlRight.children[3].findByName(tConfig[0].name);
        this.soundHolderR = cntrlRight.children[4];
        this.pSystemFloatR = cntrlRight.children[5];
        this.stickRight = cntrlRight.children[3].findByName('move').children[3];
        this.stickRotRight= cntrlRight.children[3].findByName('rotate').children[3];
        this.teleCubeR = cntrlRight.children[1].children[2];
    }

};

ControllerHandler.prototype.loadScene = function(bla) {
    if(this.tMenu){
        this.app.fire('sceneLoader:loadScene', this.sceneIndex[this.sceneCounter]); // loads next scene
    }
};

ControllerHandler.prototype.onButton = function(chnd, btn, state) {

    if(chnd == 'left'){
        //LEFT TRIGGER/INDEX BUTTON
        if(btn == 1 && state == 'down') {
            if(lTrigOnce){
                lTrigOnce = false;
                if(mcL.name == 'float'){
                   // this.pSystemFloatL.enabled = true;
                    this.soundHolderL.sound.play('thruster');
                    this.pSystemFloatL.particlesystem.reset();
                    this.pSystemFloatL.particlesystem.play();
                }
                if(mcL.name == 'teleport'){
                    this.teleCubeL.enabled = true;
                }
            }
        }
        
        if (btn == 1 && state == 'up') {
            if(!lTrigOnce){
                if(this.tMenu){
                this.tMenu = true;
                }
                if(mcL.name == 'float'){
                    this.soundHolderL.sound.stop();
                    this.pSystemFloatL.particlesystem.stop();
                    //this.pSystemFloatL.enabled = false;
                }
                if(mcL.name == 'teleport'){
                    this.soundHolderL.sound.play('teleport');
                    this.teleCubeL.enabled = true;
                }
            }
            lTrigOnce = true;
        }
        
        //LEFT GRIP/SQUEEZE BUTTON
        if(btn == 2 && state == 'down') {
            if(lGripOnce){
                animL.play(this.anim2.name); // open/close animation
                this.soundHolderL.sound.play('open');
                cntrlLeft.children[3].enabled = true; // show/hide modules
                cntrlLeft.children[3].children[2].enabled = true;
                cntrlLeft.children[3].children[3].enabled = false;
            }
            lGripOnce = false;
        }
        if (btn == 2 && state == 'up') {
            if(!lGripOnce){
                animL.play(this.anim1.name);
                this.soundHolderL.sound.play('close');
                cntrlLeft.children[3].children[2].enabled = false;
                cntrlLeft.children[3].children[3].enabled = true;
                this.app.fire('controllerHandler:updateStates', 'left', mcL.name);
            }
            lGripOnce = true;
        }
    } 
    
    else if (chnd == 'right') {

        //RIGHT TRIGGER/INDEX BUTTON
        if(btn == 1 && state == 'down') {
            if(rTrigOnce){
                rTrigOnce = false;
                if(mcR.name == 'float'){
                    this.pSystemFloatR.particlesystem.reset();
                    this.pSystemFloatR.particlesystem.play();
                    this.soundHolderR.sound.play('thruster');
                }
                if(mcR.name == 'teleport'){
                    this.teleCubeR.enabled = true;
                }
            }
        } else if (btn == 1 && state == 'up') {
            if(!rTrigOnce){
                if(this.tMenu){
                    this.tMenu = true;
                }
                if(mcR.name == 'float'){
                    this.soundHolderR.sound.stop();
                    this.pSystemFloatR.particlesystem.stop();
                }
                if(mcR.name == 'teleport'){
                    this.soundHolderR.sound.play('teleport');
                }
            }
            rTrigOnce = true;
        }
        
        //RIGHT GRIP/SQUEEZE BUTTON
        if(btn == 2 && state == 'down') {
            if(rGripOnce){
                animR.play(this.anim2.name);
                this.soundHolderR.sound.play('open');
                cntrlRight.children[3].children[3].enabled = false;
                cntrlRight.children[3].children[2].enabled = true;
            }
            rGripOnce = false;
        }
        if(btn == 2 && state == 'up') {
            if(!rGripOnce){
                animR.play(this.anim1.name);
                this.soundHolderR.sound.play('close');
                cntrlRight.children[3].children[3].enabled = true;
                cntrlRight.children[3].children[2].enabled = false;
                this.app.fire('controllerHandler:updateStates', 'right', mcR.name);
            }
            rGripOnce = true;
        }
    }

};

ControllerHandler.prototype.onControllerAxisY = function(tHnd, val, swtch) {
    
    // this function cycles between the modules on each controller.
    // controller configuration for each scene is individual and defined in array tconfig
    
    if(cntrlLeft){
        var lastModuleL = cntrlLeft.children[3].findByName(tConfig[moduleCounterL].name);
    }
    if(cntrlRight){
        var lastModuleR = cntrlRight.children[3].findByName(tConfig[moduleCounterR].name);
    }  
    
    
        if (val === 0) {
            once = true;
        }
    
        if (val !== 0) {
            
            if (once) {
                this.soundHolderL.sound.play('blip1');
                if (val < -0.12) {
                    if(tHnd == 'left'){
                        moduleCounterL += 1;
                    }
                    if(tHnd == 'right'){
                        moduleCounterR += 1;
                    }
                }
                
                if (val > 0.12) {
                    if(tHnd == 'left'){
                        moduleCounterL -= 1;
                    }
                    if(tHnd == 'right'){
                        moduleCounterR -= 1;
                    }
                }
            }
            
            //checks for each controller individually - hence moduleCounterL/R
            
            if(moduleCounterL < 0){
                moduleCounterL = tConfig.length - 1;
            } else if(moduleCounterL > tConfig.length -1){
                moduleCounterL = 0;
            }
            
            if(moduleCounterR < 0){
                moduleCounterR = tConfig.length - 1;
            } else if(moduleCounterR > tConfig.length -1){
                moduleCounterR = 0;
            }
            
            if(cntrlLeft){mcL = cntrlLeft.children[3].findByName(tConfig[moduleCounterL].name);}
            if(cntrlRight){mcR = cntrlRight.children[3].findByName(tConfig[moduleCounterR].name);}
            
            // the only exception in modules is the menu - it requires the use of x-axis
            // therefore immanent to check if the menu is active after cycling
            if(mcL){
            if(mcL.name == 'menu'){
                cntrlLeft.script.controller.menu = true;
                this.tMenu = true;
            }
            //this.app.fire('debug', 'telCb: ', this.teleCubeL.name,1);
            if(mcL.name == 'teleport'){
                this.teleCubeL.enabled = true;
            } else {
                this.teleCubeL.enabled = false;
            }
            }
            if(mcR){
            if(mcR.name == 'menu'){
                cntrlRight.script.controller.menu = true;
                this.tMenu = true;
            }
            
            if(mcR.name == 'teleport'){
                this.teleCubeR.enabled = true;
            } else {
                this.teleCubeR.enabled = false;
            }
            }
            //enable & disable resulting entities
            
            if(tHnd == 'left'){
                lastModuleL.enabled = false;
                mcL.enabled = true;
            }
            
            if(tHnd == 'right'){
                lastModuleR.enabled = false;
                mcR.enabled = true;
            }
            once = false;
        }
};

ControllerHandler.prototype.onControllerAxisX = function(tHnd, val, swtch) {
    
    //this function handles the x-axis of each controller when using the menu
    
    var mEnt = null;
    
    if(tHnd == 'left'){
        mEnt = cntrlLeft;
    } else if(tHnd == 'right'){
        mEnt = cntrlRight;
    }
    
    this.soundHolderL.sound.play('blip2');
    
    if(mEnt.children[3].children[0].script.rollMenu){
        if(val > 0.001){
            mEnt.children[3].children[0].script.rollMenu.goLeft();     // tells rollMenu.js - never open again !!! - to go left
        } else if(val < -0.001){
            mEnt.children[3].children[0].script.rollMenu.goRight();    // tells rollMenu.js - never open again !!! - to go right
        }
    }
    
    this.sceneCounter = mEnt.children[3].children[0].script.rollMenu.counter;

};

ControllerHandler.prototype.move = function (hnd, vX, vY) {
if(this.soundHolderL){
    if(this.moveSndLoopL){
        this.soundHolderL.sound.play('walk');
        this.moveSndLoopL = false;
    }
}
    
if(this.soundHolderR){
    if(this.moveSndLoopR){
        this.soundHolderR.sound.play('walk');
        this.moveSndLoopR = false;
    }
}    
    if(vX === 0){
        if(this.soundHolderL){this.soundHolderL.sound.stop();}
        if(this.soundHolderR){this.soundHolderR.sound.stop();}
        this.moveSndLoopL = true;
        this.moveSndLoopR = true;
    }
    
    if(hnd == 'left'){
        this.stickLeft.setLocalEulerAngles(vY*-20, 0, vX*30);
    } else if(hnd == 'right'){
        this.stickRight.setLocalEulerAngles(vY*-20, 0, vX*30);
    }
    
};

ControllerHandler.prototype.rotate = function (hnd, vX, vY) {
    
    if(hnd == 'left'){
        this.stickRotLeft.setLocalEulerAngles(vY*-20, 0, vX*30);
        this.soundHolderL.sound.play('teleportAlt');   
    } else if(hnd == 'right'){
        this.stickRotRight.setLocalEulerAngles(vY*-20, 0, vX*30);
        this.soundHolderL.sound.play('teleportAlt');   
    }

    
};

// update code called every frame
ControllerHandler.prototype.update = function(dt) {
    this.app.fire('debug', 'xr.supported', this.app.xr.active, 1);
};

// swap method called for script hot-reloading
// inherit your script state here
// ControllerHandler.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// http://developer.playcanvas.com/en/user-manual/scripting/

